<template lang="pug">
    v-dialog(v-model='dialog' scrollable persistent max-width='750px')
        template(v-slot:activator='{ on }')
            v-btn(icon small light v-on='on')
                v-icon mdi-trash-can-outline
        v-card.mx-lg-auto(width="100%")
            v-card-title
                span.text-h5 Remove Scorecard Criterion
            v-card-text
                v-container
                    span.text-h6 Are you sure you want to remove this scorecard criterion? You can temporarily turn off this criterion by updating the 'status' to 'draft'.

                v-container
                    ScorecardCriterionShow(
                        :scorecard-criterion="scorecardCriterion"
                        readonly
                    )

            v-card-actions.text-right
                v-spacer
                    v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='dialog = false;')
                        v-icon mdi-window-close
                        | Close
                    v-btn.ma-2(color="red" outlined ripple :disabled="!validScorecardCriterion" :loading="isSaving" @click='destroyScorecardCriterion();')
                        v-icon mdi-content-save
                        | Delete

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";

    // Data
    import { DestroyScorecardCriterion, } from "@/data";

    export default Vue.extend({
        data() {
            return {
                dialog: false,
                isSaving: false,
            }
        },
        methods: {
            destroyScorecardCriterion() {
                if (!this.validScorecardCriterion) {
                    return;
                }

                this.isSaving = true;
                DestroyScorecardCriterion(this.scorecardCriterion.scorecard_template_id, this.scorecardCriterion.scorecard_criterion_id).then((response) => {
                    if (!(response?.Error?.length > 0)) {

                        this.handleDestroyScorecardCriterion(this.scorecardCriterion);
                        this.showSnackbar("green", "Successfully deleted scorecard criterion");
                    } else {
                        this.showSnackbar("error", "Failed to delete scorecard criterion");
                    }

                    this.isSaving = false;
                    this.dialog = false;
                });
            },
        },
        computed: {
            validScorecardCriterion() {
                return this.scorecardCriterion?.scorecard_criterion_id > 0;
            },
        },
        props: {
            handleDestroyScorecardCriterion: Function,
            scorecardCriterion: Object,
            showSnackbar: Function,
        },
        components: {
            // Problem: Recursive Component - Circular References Between Components
            // Solution: use Webpack’s asynchronous import when you register the component locally
            ScorecardCriterionShow : () => import('@/components/scorecard_criterions/show.vue'),
            StrLimitTooltipText,
        },
    });
</script>

<style lang="scss" scoped>
</style>
